// @ts-expect-error legacy-hubspot-bender-context is a virtual, undeclared module
import { bender } from 'legacy-hubspot-bender-context';
const {
  staticDomainPrefix
} = bender;
export const getImageUrl = (name, extension = '.svg', isIE11 = false) => `${staticDomainPrefix}/ui-images/static-2.708/optimized/${name}${isIE11 ? '-ie11' : ''}${extension}`;